import React from 'react';
import { Moon, Sun } from 'lucide-react';

interface TopNavBarProps {
  isDarkTheme: boolean;
  onToggleTheme: () => void;
  leftContent?: React.ReactNode;
}

const TopNavBar: React.FC<TopNavBarProps> = ({ isDarkTheme, onToggleTheme, leftContent }) => {
  return (
    <header className="h-14 border-b border-slate-200 bg-slate-50 dark:bg-background dark:border-border flex items-center px-4 shadow-sm">
      <div className="flex items-center gap-2 text-sm flex-1">
        <a href="/dashboard" className="h-8 w-8 mr-2 cursor-pointer flex-shrink-0">
          <img src="/mawi-spinner.svg" alt="Mawi Logo" className="h-8 w-8" />
        </a>
        {leftContent}
      </div>
      <div className="ml-auto flex items-center gap-4">
        <button
          onClick={onToggleTheme}
          className="p-2 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
        >
          {isDarkTheme ? (
            <Sun className="w-5 h-5" />
          ) : (
            <Moon className="w-5 h-5" />
          )}
        </button>
        <div className="text-sm text-gray-500 dark:text-gray-400">Welcome User</div>
        <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center text-white text-sm font-medium">U</div>
      </div>
    </header>
  );
};

export default TopNavBar;